import { useCallback, useEffect, useState } from 'react'
import { errorMessage, listAttempts } from '../../services/admin'
import { formatShortDatetime } from './dates'
import { ATTEMPT_STATUS_CLS, ATTEMPT_STATUS_FA } from './constants'
import { lessonName } from './lessonTitle'

// ─── Attempts view ────────────────────────────────────────────────────────────

export function AttemptsView({ lessons }) {
  const [items, setItems] = useState(null)
  const [lessonId, setLessonId] = useState('')
  const [limit, setLimit] = useState(100)
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')

  const load = useCallback(async (filters) => {
    setLoading(true); setErr('')
    try { setItems(await listAttempts(filters)) }
    catch (ex) { setErr(errorMessage(ex)) }
    finally { setLoading(false) }
  }, [])

  useEffect(() => { load({}) }, [load])

  function applyFilters(e) {
    e.preventDefault()
    load({ ...(lessonId ? { lessonId } : {}), limit })
  }

  return (
    <div className="space-y-3">
      <form onSubmit={applyFilters} className="flex flex-wrap items-end gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <label className="block min-w-0 max-w-full">
          <span className="mb-1 block text-xs font-medium text-slate-600">درس</span>
          <select value={lessonId} onChange={e => setLessonId(e.target.value)}
            className="w-full max-w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none">
            <option value="">همه</option>
            {lessons.map(l => <option key={l.id} value={l.id}>{lessonName(l)}</option>)}
          </select>
        </label>
        <label className="block">
          <span className="mb-1 block text-xs font-medium text-slate-600">حداکثر تعداد</span>
          <input type="number" min="1" max="500" value={limit} onChange={e => setLimit(Number(e.target.value))}
            className="w-24 rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none" />
        </label>
        <button type="submit" disabled={loading}
          className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50">
          {loading ? '…' : 'اعمال فیلتر'}
        </button>
      </form>

      {err && <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{err}</div>}

      {items && items.length === 0 && !loading && (
        <p className="py-16 text-center text-sm text-slate-400">تلاشی یافت نشد.</p>
      )}

      {items && items.length > 0 && (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 text-xs text-slate-500">
                <th className="px-4 py-2 text-start">زمان</th>
                <th className="px-4 py-2 text-start">کاربر</th>
                <th className="px-4 py-2 text-start">درس / جمله</th>
                <th className="px-4 py-2 text-start">وضعیت</th>
                <th className="px-4 py-2 text-start">امتیازها</th>
                <th className="px-4 py-2 text-start">مدت</th>
              </tr>
            </thead>
            <tbody>
              {items.map(a => (
                <tr key={a.id} className="border-t border-slate-50 align-top">
                  <td className="whitespace-nowrap px-4 py-2 text-xs text-slate-500">{formatShortDatetime(a.createdAt)}</td>
                  <td className="px-4 py-2 text-xs text-slate-700" dir="ltr">{a.userPhone}</td>
                  <td className="px-4 py-2 text-slate-700">
                    <div className="font-medium">{a.lessonTitleEn}</div>
                    <div className="text-xs text-slate-400">#{a.sentenceIndex + 1} — {a.sentenceTextEn}</div>
                  </td>
                  <td className="px-4 py-2">
                    <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${ATTEMPT_STATUS_CLS[a.status]}`}>
                      {ATTEMPT_STATUS_FA[a.status]}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-xs text-slate-600">
                    {a.status === 'scored' ? (
                      <span>کلی {a.overall} · دقت {a.accuracy} · روانی {a.fluency} · تکمیل {a.completeness} · آهنگ {a.prosody}</span>
                    ) : a.status === 'failed' ? (
                      <span className="text-red-600">{a.errorMessage ?? 'نامشخص'}</span>
                    ) : (
                      <span className="text-slate-400">—</span>
                    )}
                  </td>
                  <td className="px-4 py-2 text-xs text-slate-500">{a.recordedSeconds != null ? `${a.recordedSeconds}s` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

/** The attempts tab (X1): the view as it was, fed from the shell's props bag. */
export function AttemptsTab({ lessons }) {
  return <AttemptsView lessons={lessons} />
}
